import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Api from "../../services/api";
import "./style.css";
import { ToastContainer, toast } from 'react-toastify';
import { MdDelete, MdEdit } from "react-icons/md";
import { BsCheck } from "react-icons/bs";
import Select from 'react-select';

export default class Activity extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: 0,
            categories: '',
            fyId: '',
            gnid: '',
            modal: false,
            editModal: false,
            deleteModal: false,
            question_id: null,
            category_id: null,
            activities: null,
            initiated_by: null,
            finalised_by: null,
            implemented_by: null,
            time_period: null,
            additional_duty: null,
            remarks: null,
            fiscal_year_id: null,
            questions: null,
            questionOptions: [],
            additionalOptions: [
                {
                    value: 1,
                    label: "पर्ने"
                },
                {
                    value: 0,
                    label: "नपर्ने"
                }
            ],
            selected: null,

        };
        this.toogleModal = this.toogleModal.bind(this);
        this.EditModal = this.EditModal.bind(this);
        this.DeleteModal = this.DeleteModal.bind(this);

    }

    _getHomeData = async () => {


        let homeRes = await Api.getActivities({ fiscal_year_id: this.state.fyId, gnid: this.state.gnid });

        if (homeRes && homeRes.response) {
            this.setState({
                categories: homeRes.response,
            });
        }
    }

    _getQuestions = async () => {
        let questions = await Api.getQuestionsList({ fiscal_year_id: this.state.fyId, gnid: this.state.gnid });
        // console.log("questions", questions.response)
        if (questions && questions.response) {
            const questionOptions = questions.response.map(item => ({
                value: item.id,
                label: `${item.indicator}:${item.name}`
            }))
            this.setState({ questionOptions });
        }
    }
    handleAdd = async (e) => {
        e.preventDefault();
        try {
            let data = await Api.addActivity({
                fiscal_year_id: this.state.fyId,
                question_id: this.state.question_id,
                activities: this.state.activities,
                initiated_by: this.state.initiated_by,
                finalised_by: this.state.finalised_by,
                implemented_by: this.state.implemented_by,
                time_period: this.state.time_period,
                additional_duty: this.state.additional_duty,
            })
            if (data.code === 200) {
                toast.success(data.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                window.location.reload();
            } else {
                toast.error(data.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } catch {

        }
    }

    handleEdit = async (e) => {
        e.preventDefault();
        try {
            let data = await Api.editActivity(this.state.selected.id, {
                fiscal_year_id: this.state.fyId,
                activities: this.state.activities === null ? this.state.selected.activities : this.state.activities,
                initiated_by: this.state.initiated_by === null ? this.state.selected.initiated_by : this.state.initiated_by,
                finalised_by: this.state.finalised_by === null ? this.state.selected.finalised_by : this.state.finalised_by,
                implemented_by: this.state.implemented_by === null ? this.state.selected.implemented_by : this.state.implemented_by,
                time_period: this.state.time_period === null ? this.state.selected.time_period : this.state.time_period,
                additional_duty: this.state.additional_duty === null ? (this.state.selected.additional_duty === true ? 1 : 0) : this.state.additional_duty,
                method: "PUT"
            })
            if (data.code === 200) {
                toast.success(data.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                window.location.reload();
            } else {
                toast.error(data.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } catch {

        }
    }

    handleDelete = async (e) => {
        e.preventDefault();
        try {
            let data = await Api.deleteActivity(this.state.selected.id, {})
            if (data.code === 200) {
                toast.success(data.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                window.location.reload();
            } else {
                toast.error(data.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }

        } catch {

        }
    }


    async componentDidMount() {
        let localData = this.props.fiscal_year_id
        let fiscal = localStorage.getItem('fiscalYear');
        let ldata = JSON.parse(localStorage.user)
        let gnid = ldata.user.gnid

        // console.log("activityprops", this.props)
        // console.log("localStorage", localStorage)
        await this.setState({
            fyId: (ldata.fiscal_year_id ? ldata.fiscal_year_id : fiscal),
            gnid: gnid
        })
        this._getHomeData();
        this._getQuestions();

        // console.log("fyId", this.state.fyId)


    }
    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    toogleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }
    EditModal() {
        this.setState({
            editModal: !this.state.editModal
        });
    }
    DeleteModal() {
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    }
    render() {
        const { categories, questionOptions, additionalOptions, selected, activities, finalised_by } = this.state;
        return (
            <div className='mt-4' >
                <ToastContainer />
                <div className='d-flex justify-content-between'>
                    <h4 className='heading'>लैससास विकास कार्ययोजना</h4>

                </div>
                <div>

                </div>
                <div className='p-3 rounded bg-white mt-3'>
                    <div className=" mt-3 bg-white">
                        <div>
                            <div className='mb-2 d-flex d-flex justify-content-end'>
                                <button className='btn btn-primary' onClick={this.toogleModal}>लैससास विकास कार्ययोजना थप्नुहोस्</button>
                                <Modal isOpen={this.state.modal} toggle={this.toogleModal}>
                                    <ModalHeader toggle={this.toggleModal}>लैससास विकास कार्ययोजना थप्नुहोस्</ModalHeader>
                                    <ModalBody>
                                        <form onSubmit={(e) => {
                                            this.handleAdd(e);
                                        }}>
                                            <div>
                                                <div className='formdiv'>
                                                    <label className='formlabel'>प्रश्न</label>
                                                    <Select className='bg-light' styles={{
                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            backgroundColor: state.isFocused ? 'white' : '#F8F9FA',
                                                        }),

                                                    }}
                                                        placeholder={<div>प्रश्न</div>}
                                                        isSearchable={true}
                                                        options={questionOptions}
                                                        onChange={(e) => this.setState({ question_id: e.value })}
                                                    />
                                                </div>
                                                <div className='formdiv'>
                                                    <label className='formlabel'>अवस्था सुधारका लागि आवश्यक क्रियाकलाप</label>
                                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                                    {/* {console.log("activities", activities)} */}
                                                </div>
                                                <div className='formdiv'>
                                                    <label className='formlabel'>पहलकर्ता</label>
                                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ initiated_by: e.target.value }) }} />
                                                    {/* {console.log("finalised_by", finalised_by)} */}
                                                </div>
                                                <div className='formdiv'>
                                                    <label className='formlabel'>निर्णायकर्ता</label>
                                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ finalised_by: e.target.value }) }} />
                                                </div>
                                                <div className='formdiv'>
                                                    <label className='formlabel'>कार्यान्वयनकर्ता</label>
                                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ implemented_by: e.target.value }) }} />
                                                </div>
                                                <div className='formdiv'>
                                                    <label className='formlabel'>समयावधि</label>
                                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ time_period: e.target.value }) }} />
                                                </div>
                                                <div className='formdiv'>
                                                    <label className='formlabel'>थप दायित्व</label>
                                                    <Select className='bg-light' styles={{
                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            backgroundColor: state.isFocused ? 'white' : '#F8F9FA',
                                                        }),

                                                    }}
                                                        placeholder={<div>पर्ने/नपर्ने</div>}
                                                        options={additionalOptions}
                                                        onChange={(e) => { this.setState({ additional_duty: e.value }) }}
                                                    />
                                                    {/* <Input required type="select" className='form-control bg-light' onChange={(e) => { this.setState({ additional_duty: e.target.value }) }} >
                                                        <option value={0}>Pardaina</option>
                                                        <option value={1}>Parcha</option>
                                                    </Input> */}
                                                </div>
                                                {/* <div className='formdiv'>
                                                    <label className='formlabel'>Remarks</label>
                                                    <input className='form-control bg-light' onChange={(e) => { this.setState({ remarks: e.target.value }) }} />
                                                </div> */}
                                                <div className='formdiv'>
                                                    <button className='btn btn-primary'>Submit</button>
                                                </div>
                                            </div>

                                        </form>
                                    </ModalBody>
                                </Modal>
                            </div>

                            <div className='table-responsive'>

                                <table className='table table-bordered text-center'>
                                    <thead style={{ backgroundColor: "#F6F6F6" }}>
                                        <tr>
                                            <th colSpan={3}>मूल शिर्षक</th>
                                            <th rowSpan={2} className='align-middle'>अवस्था सुधारका लागि आवश्यक क्रियाकलाप</th>
                                            <th colSpan={3}>क्रियाकलाप सञ्चालन गर्ने जिम्मेवारी</th>
                                            <th rowSpan={2} className=' align-middle'>समयावधि</th>
                                            <th colSpan={2}>थप दायित्व पर्ने/नपर्ने</th>
                                            <th rowSpan={2} className=' align-middle'>कार्यहरू</th>
                                        </tr>
                                        <tr>
                                            <td>प्रश्न</td>
                                            <td>पूर्णाङ्क</td>
                                            <td>प्राप्ताङ्क</td>

                                            <td>पहलकर्ता</td>
                                            <td>निर्णायकर्ता</td>
                                            <td>कार्यान्वयनकर्ता</td>

                                            <td>पर्ने</td>
                                            <td>नपर्ने</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {categories.length > 0 ? categories.map((category) => (
                                            <tr>
                                                <td>{category.question.indicator}</td>
                                                <td>{category.question.marks}</td>
                                                <td>{category.question.answer.score}</td>
                                                <td>{category.activities}</td>
                                                <td>{category.initiated_by}</td>
                                                <td>{category.finalised_by}</td>
                                                <td>{category.implemented_by}</td>
                                                <td>{category.time_period}</td>
                                                <td >{category.additional_duty === true ? <BsCheck style={{ fontWeight: "bold" }} /> : ""}</td>
                                                <td>{category.additional_duty === false ? <BsCheck /> : ""}</td>

                                                <td>
                                                    <div className='d-flex justify-content-end '>
                                                        <button className=' btn  mx-1 btn-light'>
                                                            <MdEdit className='m-1' onClick={() => { this.EditModal(); this.setState({ selected: category }) }} />
                                                        </button>
                                                        <button className='btn mx-1 btn-light'>
                                                            <MdDelete className='m-1' onClick={() => { this.DeleteModal(); this.setState({ selected: category }) }} />
                                                        </button>
                                                    </div>
                                                    <Modal isOpen={this.state.editModal} toggle={this.EditModal}>
                                                        <ModalHeader toggle={this.EditModal}>लैससास विकास कार्ययोजना Edit</ModalHeader>
                                                        <ModalBody>
                                                            <form onSubmit={(e) => {
                                                                this.handleEdit(e);
                                                            }}>
                                                                <div>
                                                                    <div className='formdiv'>
                                                                        <label className='formlabel'>अवस्था सुधारका लागि आवश्यक क्रियाकलाप</label>
                                                                        <input className='form-control bg-light' defaultValue={this.state.selected ? this.state.selected.activities : ""} onChange={(e) => { this.setState({ activities: e.target.value }) }} />
                                                                    </div>
                                                                    <div className='formdiv'>
                                                                        <label className='formlabel'>पहलकर्ता</label>
                                                                        <input className='form-control bg-light' defaultValue={this.state.selected && this.state.selected.initiated_by} onChange={(e) => { this.setState({ initiated_by: e.target.value }) }} />
                                                                    </div>
                                                                    <div className='formdiv'>
                                                                        <label className='formlabel'>निर्णायकर्ता</label>
                                                                        <input className='form-control bg-light' defaultValue={this.state.selected && this.state.selected.finalised_by} onChange={(e) => { this.setState({ finalised_by: e.target.value }) }} />
                                                                    </div>
                                                                    <div className='formdiv'>
                                                                        <label className='formlabel'>कार्यान्वयनकर्ता</label>
                                                                        <input className='form-control bg-light' defaultValue={this.state.selected && this.state.selected.implemented_by} onChange={(e) => { this.setState({ implemented_by: e.target.value }) }} />
                                                                    </div>
                                                                    <div className='formdiv'>
                                                                        <label className='formlabel'>समयावधि</label>
                                                                        <input className='form-control bg-light' defaultValue={this.state.selected && this.state.selected.time_period} onChange={(e) => { this.setState({ time_period: e.target.value }) }} />
                                                                    </div>
                                                                    <div className='formdiv'>
                                                                        <label className='formlabel'>थप दायित्व</label>
                                                                        <Select className='bg-light' styles={{
                                                                            control: (baseStyles, state) => ({
                                                                                ...baseStyles,
                                                                                backgroundColor: state.isFocused ? 'white' : '#F8F9FA',
                                                                            }),

                                                                        }}
                                                                            placeholder={<div>पर्ने/नपर्ने</div>}
                                                                            options={additionalOptions}
                                                                            defaultValue={selected && selected.additional_duty === true ? additionalOptions[0] : additionalOptions[1]}
                                                                            onChange={(e) => { this.setState({ additional_duty: e.value }) }}
                                                                        />

                                                                    </div>
                                                                    <div className='formdiv'>
                                                                        <button className='btn btn-primary'>Submit</button>
                                                                    </div>
                                                                </div>

                                                            </form>
                                                        </ModalBody>
                                                    </Modal>

                                                    <Modal size="sm" centered style={{ maxWidth: '560px', width: '100%' }} isOpen={this.state.deleteModal} toggle={this.DeleteModal}>
                                                        <ModalBody>
                                                            <div className="d-flex flex-column justify-content-center align-items-center border-bottom py-3">
                                                                <div className="d-flex flex-column justify-content-center align-items-center">
                                                                    <img style={{ maxHeight: 64, maxWidth: "64px" }} alt="Delete Icon" />
                                                                </div>
                                                                <div className="d-flex flex-column justify-content-center align-items-center text-center">
                                                                    <p syle={{ fontWeight: 700, fontSize: "14px", fontFamily: "Mukta" }}>लैससास विकास कार्ययोजना रद्द गर्ने?</p>
                                                                    <span className="text-center" style={{ fontSize: "14px", fontWeight: 400, fontFamily: "Mukta", color: "#5C6C74" }}>के तपाइँ यो लैससास विकास कार्ययोजना रद्दगर्न चाहनु हुन्छ? यो कार्य परिवर्तन गर्न सकिँदैन।</span>
                                                                </div>
                                                            </div>

                                                            <form onSubmit={(e) => {
                                                                this.handleDelete(e);
                                                            }}>
                                                                <div className="d-flex justify-content-start">
                                                                    <button type="button" className=" btn btn fw-bold bg-danger text-white col-6" onClick={this.DeleteModal}>होइन</button>
                                                                    <button type="submit" className=" btn btn fw-bold  mx-2 bg-primary text-white col-6">हो</button>
                                                                </div>

                                                            </form>
                                                        </ModalBody>
                                                    </Modal>

                                                </td>
                                            </tr>
                                        )) : <h1 className='pt-4'>विवरण उपलब्ध छैन</h1>}
                                    </tbody>
                                </table>



                            </div>
                        </div>
                    </div>
                </div>

            </div >
        );
    }
}